import React from "react";
import { AnchorMenu } from "../../components/anchor-menu";
import { Capstone } from "./sections/capstone";
import { Team } from "./sections/team";

export enum AboutAnchor {
    CAPSTONE = "capstone",
    TEAM = "team"
}

export interface IAboutProps {
    currAnchor: string;
    showAnchorMenu: boolean;
    handleMenuClick: (anchor: string) => void;
    onComponentMounted: (anchorList: string[]) => void;
}

export class About extends React.Component<IAboutProps> {
    public static readonly ANCHOR_LIST: string[] = [
        AboutAnchor.CAPSTONE,
        AboutAnchor.TEAM
    ];

    componentDidMount() {
        this.props.onComponentMounted(About.ANCHOR_LIST.slice());
    }

    render() {
        return (
            <React.Fragment>
                {
                    this.props.showAnchorMenu
                        ? <AnchorMenu
                            selectedAnchor={this.props.currAnchor || AboutAnchor.CAPSTONE}
                            handleMenuClick={this.props.handleMenuClick}
                            anchorList={About.ANCHOR_LIST.slice()}
                        />
                        : undefined
                }
                <main>
                    <article>
                        <Capstone
                            sectionId={AboutAnchor.CAPSTONE}
                            index={About.ANCHOR_LIST.indexOf(AboutAnchor.CAPSTONE)}
                        />
                        <Team
                            sectionId={AboutAnchor.TEAM}
                            index={About.ANCHOR_LIST.indexOf(AboutAnchor.TEAM)}
                        />
                    </article>
                </main>
            </React.Fragment>
        );
    }

}